import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    width: '100%',
    padding: [theme.spacing(2), theme.spacing(4)],
    boxShadow: '-8px 0px 12px rgba(92, 131, 150, 0.08)',
    backgroundColor: 'rgba(224, 242, 241, 0.15)',
  },
  text: {
    letterSpacing: '0.03em',
    textTransform: 'uppercase',
    color: 'rgba(0, 0, 0, 0.6)',
    fontWeight: 'normal',
    fontSize: 22,
  },
  homePrice: {
    marginLeft: theme.spacing(1),
    fontSize: 22,
  },
  divider: {
    margin: [theme.spacing(1), 0],
    width: '100%',
    borderBottom: [1, 'solid', theme.palette.colors.teal],
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/MothlyPaymentCalculator/components/MobileCalculationsResult/useStyles.js